/**
 * @author Karl Jones
 * @email karljones@live.ie
 * @create date 2022-12-10 13:45:02
 * @modify date 2022-12-10 13:45:02
 * @desc display an announcement bar to visitors of the site, this uses data from the data folder in order to populate.
 */

import { Link } from 'react-router-dom';

import Typography from '@mui/material/Typography'

interface IAnnouncementBra {
    message: string;
    learnMore: string;
}

const AnnouncementBar = ({ message, learnMore }: IAnnouncementBra) => {
    return (
        <Link data-testid="announcementbar" style={{ color: 'white', fontSize: '16px', textDecoration: 'none' }} to={learnMore}>
            <div className={`AnnouncementBar--container`}>
                <div>
                    <Typography
                        className="AnnouncementBar--content"
                        variant="body1"
                        style={{ fontSize: '16px' }}>
                        {message}
                    </Typography>
                </div>
            </div>
        </Link >
    )
}

export default AnnouncementBar;